import { ACTION_TYPES } from "../utils/Constants";


const initialState = {
  latestMessages: "",
  senderUserId: "",
  receiverUserId: "",
  CreatedTime: "",
  readStatus: true,
};

const latestMessageReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.UPDATE_LATEST_MESSAGE:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default latestMessageReducer;
